module.exports = __webpack_public_path__ + "media/v2/components/PrizesPage/shared/img/4-aaeae493a1853f08e1d5f573ebb10b60.png";